import {listSave, setSession, getSession} from '../../tools/config'

let obj = {
    state: {


        serviceSheet: {

            name: '',
            address: '',
            comments: '',
            alias: '',
            startDate: '',
            endDate: '',
            statusList: [],

        },


    },
    mutations: {
        //服务工单
        setListServiceSheet(state, info) {
            setSession(listSave, info)
            state.serviceSheet = info
        },
        resetListServiceSheet(state) {
            setSession(listSave, {
                name: '',
                address: '',
                comments: '',
                alias: '',
                startDate: '',
                endDate: '',
                statusList: [],
            })
            state.serviceSheet = {
                name: '',
                address: '',
                comments: '',
                alias: '',
                startDate: '',
                endDate: '',
                statusList: [],
            }
        },

    },
    getters: {
        //服务工单
        getListServiceSheet(state) {
            state.serviceSheet = getSession(listSave)
            return state.serviceSheet
        },

    }
}

export default obj



// WEBPACK FOOTER //
// ./src/store/modules/listSave.js